declare global {
  interface Window {
    SC_AUDIT_STUDIO_API_BASE_PATH?: string;
  }
}

const DEFAULT_API_BASE_PATH = 'https://ai.scauditstudio.com/backend';
const LOCAL_API_BASE_PATH = '/backend';

const trimTrailingSlashes = (value: string): string => {
  return value.replace(/\/+$/, '');
};

const isLocalHostname = (hostname: string): boolean => {
  return hostname === 'localhost'
    || hostname === '127.0.0.1'
    || hostname === '[::1]'
    || hostname.endsWith('.localhost');
};

const getApiBasePath = (): string => {
  const configuredApiBasePath = (
    window.SC_AUDIT_STUDIO_API_BASE_PATH ||
    process.env.REACT_APP_API_BASE_PATH ||
    ''
  ).trim();

  if (configuredApiBasePath) {
    return trimTrailingSlashes(configuredApiBasePath);
  }

  return isLocalHostname(window.location.hostname)
    ? LOCAL_API_BASE_PATH
    : DEFAULT_API_BASE_PATH;
};

export const API_BASE_PATH = getApiBasePath();
